<template>
  <div>
    <a-spin tip="資料處理中..." :spinning="iconLoading">
      <a-button
        type="primary"
        :disabled="selectedRows.length==0"
        @click="enterView"
      >
      <b-icon style="margin-right: 0.3rem;" scale="1.1" icon="printer" variant="muted" />
      列印
    </a-button> <span style="color:red" v-if="selectedRows.length>0" v-text="' 您選擇的數量 : '+selectedRows.length +' (一次列印筆數勿超過 200 組QR Code)'" />
      <a-table
        :columns="columns"
        :row-key="record => record.uid"
        :data-source="list"
        :pagination="{ pageSize: 10 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys,selectedRows:selectedRows, onChange: onSelectChange }"
        :scroll="{ x: 1100, y: 380 }"
      >
        <template slot="checked" slot-scope="record">
          <b-icon style="margin-right: 0.3rem;" scale="1.1" icon="people" variant="muted" />
          <span v-text="record.checked?'會員':'非會員'"></span>
        </template>
        <template slot="created_at" slot-scope="record">
          <span v-text="fdateformat(record.created_at)"></span>
        </template>
        <!--<template slot="action" slot-scope="record">
          <a-button 
            type="primary" 
            size="small" 
            @click="editMember(record)"
            :loading="record.editLoading"
          >
            <b-icon icon="pencil" scale="0.9" style="margin-right: 4px;"/>
            修改
          </a-button>
        </template>-->
      </a-table>

      <b-modal
        ref="my-list"
        id="modal-2"
        title="選項"
        size="lg"
        @hide="onHide"
        scrollable
        centered
        hide-footer
        hide-header
      >
        <div class="text-center">
          <a-button @click="closeModal()" type="link" :disabled="iconLoading2" size="small">(關閉)</a-button>
          <a-button
            type="primary"
            :disabled="selectedRows.length==0 && selectedRows.length<=200"
            :loading="iconLoading2"
            @click="exportToPDF"
          >
          <b-icon style="margin-right: 0.3rem;" scale="1.1" icon="printer" variant="muted" />
          列印</a-button>
          <div class="classempy" id="word1head">
            <h6>
              <strong>
                <span v-text="defaultval.name + ', 會員QR Code 輸出共 :' + selectedRows.length +' 組QR Code'"></span>
              </strong>
            </h6>
          </div>
          <div id="word123">
            <div
              class="list-group-item"
              :id="'word' + element.uid"
              style="padding:0.5rem;margin:2px;"
              v-for="element in selectedRows"
              :key="element.uid"
            >
              <b-container class="container">
                <b-row>
                  <b-col style="padding:0;">
                    <div class="text-center">
                      <span v-text="element.username +'|'+element.account " />
                      <div class="qrbody">
                        <vue-qr
                          ref="qrCode"
                          :text="'actjoin:'+element.uid"
                          :logoScale="20"
                          :size="250"
                          :margin="10"
                        />
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:0;text-align:left;">
                    <div style="display: flex;height: 300px;align-items: center; /* ★ */">
                      <strong>
                        <span
                          style="padding:1px;margin:1px;font-size: 16px;"
                          v-text="'顯示名稱 : ' + element.username"
                        />
                        <br />
                        <span
                          style="padding:1px;margin:1px;font-size: 16px;"
                          v-text="'帳號 : ' + element.account"
                        />
                        <br />
                        <span
                          style="padding:1px;margin:1px;font-size: 16px;"
                          v-text="'地址 : ' + element.address"
                        />
                        <br />
                        <span
                          style="padding:1px;margin:1px;font-size: 16px;"
                          v-text="'電話 : ' + element.phone"
                        />
                        <br />
                        <span
                          style="padding:1px;margin:1px;font-size: 16px;"
                          v-text="'建立日期 : ' + fdateformat(element.created_at) "
                        />
                        <br />
                        <span
                          style="padding:1px;margin:1px;font-size: 16px;"
                          v-text="'初始密碼 : ' + element.password "
                        />
                      </strong>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- 編輯會員資料 Modal -->
      <b-modal
        ref="edit-member"
        id="modal-edit"
        title="修改會員資料"
        size="md"
        @hide="onEditHide"
        scrollable
        centered
        hide-footer
        no-close-on-backdrop
      >
        <div v-if="editingMember">
          <!-- 訊息顯示區域 - 使用 v-if 直接控制 -->
          <div 
            v-if="editMessage" 
            class="edit-msg-box" 
            :class="'edit-msg-' + editMessageType"
          >
            <span v-text="editMessage"></span>
            <button type="button" class="edit-msg-close" @click="hideEditMessage">&times;</button>
          </div>
          
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group label="顯示名稱" label-for="edit-username">
                  <b-form-input 
                    id="edit-username"
                    v-model="editingMember.username" 
                    placeholder="請輸入顯示名稱"
                    @input="validateForm"
                    :disabled="editLoading"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="密碼" label-for="edit-password">
                  <b-form-input 
                    id="edit-password"
                    v-model="editingMember.password" 
                    placeholder="請輸入密碼"
                    @input="validateForm"
                    :disabled="editLoading"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="電話" label-for="edit-phone">
              <b-form-input 
                id="edit-phone"
                v-model="editingMember.phone" 
                placeholder="請輸入電話"
                @input="validateForm"
                :disabled="editLoading"
              />
            </b-form-group>
            <b-form-group>
              <label>
                <code> * </code>地址 : 
                <a-button @click="getAddress()" type="link" size="small" :disabled="editLoading">
                  <a-icon :style="{ fontSize: '20px', color: '#08c' }" type="home" />
                  (選取地址)
                </a-button>
                <span style="color:crimson;font-size: 14px;" v-text="'⚙街道路號可選填'"></span>
              </label>
              <b-form-input 
                v-model="editingMember.address" 
                placeholder="請輸入地址"
                @input="validateForm"
                :disabled="editLoading"
                required
              />
            </b-form-group>
          </b-form>
          
          <!-- 載入狀態顯示 -->
          <div v-if="editLoading" class="text-center mt-3">
            <b-spinner variant="primary" label="處理中..."></b-spinner>
            <p class="mt-2">正在更新會員資料...</p>
          </div>

          <!-- 自訂底部按鈕 -->
          <div class="edit-modal-footer">
            <a-button @click="cancelEdit" :disabled="editLoading">取消</a-button>
            <a-button 
              type="primary" 
              @click="saveMember" 
              :disabled="!isFormValid || editLoading"
              :loading="editLoading"
            >儲存</a-button>
          </div>
        </div>
      </b-modal>

      <!-- 地址選擇 Modal -->
      <b-modal
        ref="my-address"
        id="modal-address"
        title="地址選擇"
        size="lg"
        @hide="closeAddressModal"
        scrollable
        centered
        hide-footer
      >
        <div class="text-center">
          <a-button @click="closeAddressModal()" type="link" size="small">(關閉)</a-button>
          <Addresslistcom @toaddress="toaddress" />
        </div>
      </b-modal>
    </a-spin>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { userService } from "../../../_services/";
import * as moment from "moment/moment";
import VueQr from "vue-qr";
import logoImg from "@/assets/lineicon.svg";
import html2pdf from "html2pdf.js";
import Addresslistcom from "../../../components/Addresslist.vue";

const queryData = params => {
  return userService.getMylist(params);
};

const columns = [
  {
    title: "會員",
    dataIndex: "",
    scopedSlots: { customRender: "checked" },
    width: 80
  },
  {
    title: "顯示名稱",
    dataIndex: "username",
    width: 120
  },
  {
    title: "帳號",
    dataIndex: "account",
    width: 120
  },
  {
    title: "密碼",
    dataIndex: "password",
    width: 120
  },  
  {
    title: "地址",
    dataIndex: "address",
    width: 180
  },
  {
    title: "電話",
    dataIndex: "phone",
    width: 120
  },
  {
    title: "建立日期",
    dataIndex: "",
    scopedSlots: { customRender: "created_at" },
    width: 140
  },
  /*{
    title: "操作",
    dataIndex: "",
    scopedSlots: { customRender: "action" },
    width: 120,
    fixed: 'right'
  }*/
];

export default {
  name: "Mymenber",
  components: {
    VueQr,
    Addresslistcom
  },
  data() {
    return {
      list: [],
      iconLoading: false,
      iconLoading2: false,
      columns,
      selectedRowKeys: [],
      selectedRows: [],
      logoPath: logoImg,
      editingMember: null,
      originalMember: null,
      isFormValid: false,
      editLoading: false,
      editMessage: '',
      editMessageType: 'success' // success, danger, warning, info
    };
  },
  mounted() {
    //this.reload()
    
    // Avoid page-breaks on all elements, and add one before #page2el.
    html2pdf().set({
      pagebreak: { mode: "avoid-all", before: "#page2el" }
    });

    // Enable all 'modes', with no explicit elements.
    html2pdf().set({
      pagebreak: { mode: ["avoid-all", "css", "legacy"] }
    });

    // No modes, only explicit elements.
    html2pdf().set({
      pagebreak: {
        before: ".beforeClass",
        after: ["#after1", "#after2"],
        avoid: "img"
      }
    });
  },
  watch: {
    defaultval() {
      this.reload();
    }
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["datas", "defaultval"]),
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },

  },

  methods: {
    reload() {
      this.fetch();
    },

    fetch(
      params = {
        id: this.defaultval.id
      }
    ) {
      this.iconLoading = true;
      queryData({
        ...params
      }).then(({ data }) => {
        let obj = data;
        if (obj != null) {
          setTimeout(() => {
            this.list = obj;
            this.iconLoading = false;
          }, 600);
        } else {
          this.iconLoading = false;
        }
      });
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      //console.log('selectedRowKeys changed: ', selectedRowKeys,selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },

    fdateformat(val) {
      return moment(val).format("YYYY-MM-DD");
    },

    enterView() {
      this.$refs["my-list"].show();
    },
    closeModal() {
      this.$refs["my-list"].hide();
    },
    groupBy(list, keyGetter) {
      //group by
      const map = new Map();
      list.forEach(item => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    },

    exportToPDF() {
      // pdf匯出設定
      this.iconLoading2 = true;
      this.iconLoading = true;
      const opt = {
        margin: 0.3,
        filename: "QrCode_member.pdf",
        image: { type: "jpeg", quality: 0.99 },
        //pagebreak: { avoid: "tr", mode: "css", before: "#nextpage1", after: "1cm" },
        html2canvas: { dpi: 192, letterRendering: true, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
      };
      this.domList = [];
      // 抓取各個圖片的DOM元素，並把它裝入doc這個陣列裡
      let newDiv = document.createElement("div");
      //let j = this.items.act_detrimal.length
      let head1 = document.getElementById("word1head");
      const clone1 = head1.cloneNode(true);
      newDiv.appendChild(clone1);

      //let element1 = document.getElementById("word123");

      let tmp = [];
      for (let item in this.selectedRows) {
        let element1 = document.getElementById(
          "word" + this.selectedRows[item].uid
        );
        const i = parseInt(item / 3);
        let obj = {
          id: i,
          el: element1
        };
        tmp.push(obj);
      }
      const grouped = this.groupBy(tmp, pet => pet.id); //Group by
      grouped.forEach((rs) => {
        let iDiv = document.createElement("div");
        rs.forEach((cs)=>{
          const clone1 = cs.el.cloneNode(true);
          iDiv.appendChild(clone1);
          //console.log(cs.el,cs.id)
        })
        this.domList.push(iDiv);
      });
      let iDiv2 = document.createElement("div");
      this.domList.push(iDiv2);
      //console.log(this.domList)
      if (this.domList.length > 0) {
        // 開始進行列印
        let doc = html2pdf()
          .from(this.domList[0])
          .set(opt)
          .toPdf();
        for (let j = 1; j < this.domList.length - 1; j++) {
          doc = doc
            .get("pdf")
            .then(pdf => pdf.addPage())
            .from(this.domList[j])
            .toContainer()
            .toCanvas()
            .toPdf();
        }
        // 列印完成輸出done
        doc
          .save()
          .then(
            () => ((this.iconLoading = false), (this.iconLoading2 = false))
          );
      }
    },

    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
    },

    // 編輯會員相關方法
    editMember(record) {
      // 清理之前的訊息
      this.editMessage = '';
      this.editLoading = false;
      
      // 深拷貝原始資料以便取消時復原
      this.originalMember = JSON.parse(JSON.stringify(record));
      this.editingMember = JSON.parse(JSON.stringify(record));
      this.validateForm();
      this.$refs["edit-member"].show();
    },

    showEditMessage(message, type = 'success') {
      this.editMessage = message;
      this.editMessageType = type;
      // 強制更新視圖
      this.$nextTick(() => {
        console.log('顯示訊息:', message, '類型:', type);
      });
    },

    hideEditMessage() {
      this.editMessage = '';
    },

    saveMember() {
      // 清理之前的訊息
      this.hideEditMessage();
      
      if (!this.isFormValid) {
        this.showEditMessage('請確認所有必填欄位都已填寫', 'warning');
        return;
      }
      
      // 準備更新資料 (只更新允許編輯的欄位)
      const updateData = {
        uid: this.editingMember.uid,
        username: this.editingMember.username,
        password: this.editingMember.password,
        phone: this.editingMember.phone,
        address: this.editingMember.address
      };
      
      console.log('準備更新會員資料:', updateData);
      this.editLoading = true;
      
      // 呼叫後端 API
      userService.updateMember(updateData).then(response => {
        console.log('API 回應:', response);
        
        if (response && response.data) {
          // 更新成功，使用後端返回的最新資料
          const updatedMember = response.data;
          const index = this.list.findIndex(item => item.uid === updatedMember.uid);
          
          if (index >= 0) {
            // 保持原有的資料結構，只更新允許編輯的欄位
            this.$set(this.list, index, {
              ...this.list[index],
              username: updatedMember.username,
              password: updatedMember.password,
              phone: updatedMember.phone,
              address: updatedMember.address
            });
          }
          
          // 顯示成功訊息
          this.showEditMessage('🎉 會員資料更新成功！', 'success');
          
        } else {
          // API 回應格式異常
          this.showEditMessage('❌ 更新失敗：API 回應格式異常', 'danger');
        }
        
        this.editLoading = false;
      }).catch(error => {
        console.error('API 錯誤:', error);
        
        // 處理錯誤情況
        let errorMsg = '❌ 更新失敗：';
        if (error.response && error.response.data) {
          if (typeof error.response.data === 'string') {
            errorMsg += error.response.data;
          } else if (error.response.data.Msg) {
            errorMsg += error.response.data.Msg;
          } else {
            errorMsg += '伺服器錯誤';
          }
        } else if (error.message) {
          errorMsg += error.message;
        } else {
          errorMsg += '網路錯誤或伺服器無回應';
        }
        
        this.showEditMessage(errorMsg, 'danger');
        this.editLoading = false;
      });
    },

    onEditHide() {
      // 清理編輯狀態
      this.editingMember = null;
      this.originalMember = null;
      this.isFormValid = false;
      this.editLoading = false;
      this.editMessage = '';
    },

    validateForm() {
      if (!this.editingMember) {
        this.isFormValid = false;
        return;
      }
      
      // 驗證必填欄位 (只需驗證顯示名稱和密碼)
      const required = ['username', 'password'];
      this.isFormValid = required.every(field => 
        this.editingMember[field] && 
        this.editingMember[field].trim().length > 0
      );
    },

    cancelEdit() {
      this.$refs["edit-member"].hide();
    },

    // 地址選擇相關方法
    getAddress() {
      this.$refs["my-address"].show();
    },

    closeAddressModal() {
      this.$refs["my-address"].hide();
    },

    toaddress(val, city, village, town) {
      if (this.editingMember) {
        this.editingMember.address = val;
        // 可以選擇性儲存城市、鄉鎮、村里資訊
        this.editingMember.city = city;
        this.editingMember.village = village;
        this.editingMember.town = town;
        this.validateForm();
        //this.closeAddressModal();
      }
    }
  }
};
</script>
<style scoped>
.qrbody {
  padding: 0.4rem;
  color: white;
  border-radius: 0 0 0.5rem 0.5rem;
  border-color: #3e3e3e;
  border-width: 0.35rem;
}

/* 編輯 Modal 訊息樣式 */
.edit-msg-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  margin-bottom: 12px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}
.edit-msg-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.edit-msg-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.edit-msg-warning {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}
.edit-msg-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}
.edit-msg-close {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.6;
  padding: 0 4px;
  margin-left: 8px;
}
.edit-msg-close:hover {
  opacity: 1;
}

/* 編輯 Modal 底部按鈕 */
.edit-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
}
</style>